import ModeleSaisieFormController from './modele.saisie.form.controller';

export default {
    template: require('./modele.saisie.form.html'),
    controller: ModeleSaisieFormController
};
